<template>
    <div class="full" :style="{ width: innerWidth + 'px', height: innerHeight + 'px' }">
        <div class="test_one" @click="selectProject(true)"
            :style="{ transform: 'scale(' + innerWidth / chartDatas.canvasConfig.width + ',' + innerHeight / chartDatas.canvasConfig.height + ')', 'background-image': canvasConfig.backgroundImage ? `url(${commenUrl + canvasConfig.backgroundImage})` : '', 'background-color': canvasConfig.background ? canvasConfig.background : '' }">
            <div :style="{ width: chartDatas.canvasConfig.width + 'px', height: chartDatas.canvasConfig.height + 'px' }">
                <div class="topHeaderOne">
                    <div class="titBox">
                        <span class="t">科右中旗肉牛全产业链大数据中心</span>
                        <!-- <span class="icon"></span> -->
                        <span class="icon"><el-icon>
                                <!-- <FullScreen /> -->
                            </el-icon></span>
                    </div>
                    <div class="navBox">
                        <div :class="item.value == activeIndex ? 'item active' : 'item'"
                            v-for="(item, index) in navList" :key="index">
                            <span class="name">{{ item.name }}</span>
                            <img v-if="index != navList.length - 1" class="lineIcon"
                                src="../../images/keYou/nav_line.png" alt="">
                        </div>
                    </div>
                    <!-- <div class="dateBox">
                {{dayInfo.day}}<br />
                {{dayInfo.time}}
            </div> -->
                </div>
                <div class="dataCenter">
                    <div class="timeLine">
                        <div class="timeline">
                            <div class="item" v-for="(item, index) in yearList" :key="index"
                                :class="activeId == item.id ? 'activeItem item' : 'item'" @click="yearChange(item)">
                                <div class="time">
                                    {{ item.year }}年
                                </div>
                                <div class="line"></div>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="topBox">
                            <div class="topLeftBox_two">
                                <div class="topLeftBox topLeftBox1">
                                    <div class="toptit">一产发展({{ initData.dataOne[0]?.year }})</div>
                                    <div class="countBox">
                                        <div class="left">
                                            <div class="item">
                                                <div class="name">肉牛存栏</div>
                                                <div class="count">
                                                    <span class="num" v-if="initData.dataTwo[0]?.bcStorage">{{
                                                        toFloat(initData.dataTwo[0]?.bcStorage || '0')[0] }}</span>
                                                    <span class="num" v-else>-</span>
                                                    <br />
                                                    <span class="unit" v-if="initData.dataTwo[0]?.bcStorage">{{
                                                        toFloat(initData.dataTwo[0]?.bcStorage || '0')[1] }}万头</span>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div class="name">肉牛出栏</div>
                                                <div class="count">
                                                    <span class="num" v-if="initData.dataTwo[0]?.bcOut">{{
                                                        toFloat(initData.dataTwo[0]?.bcOut || '0')[0] }}</span>
                                                    <span class="num" v-else>-</span>
                                                    <br />
                                                    <span class="unit" v-if="initData.dataTwo[0]?.bcOut">{{
                                                        toFloat(initData.dataTwo[0]?.bcOut || '0')[1] }}万头</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <div class="name">饲草料</div>
                                            <div class="lineBox">
                                                <div class="item">
                                                    <div class="tit">储草棚</div>
                                                    <div class="num" v-if="initData.dataOne[0]?.hayshed"><span
                                                            class="bigT">{{ toFloat(initData.dataOne[0]?.hayshed)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataOne[0]?.hayshed || '0')[1] }}万平方米</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">青贮窖</div>
                                                    <div class="num" v-if="initData.dataOne[0]?.silo"><span
                                                            class="bigT">{{ toFloat(initData.dataOne[0]?.silo)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataOne[0]?.silo)[1] }}万吨</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">年产青贮饲料</div>
                                                    <div class="num" v-if="initData.dataOne[0]?.silage"><span
                                                            class="bigT">{{ toFloat(initData.dataOne[0]?.silage)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataOne[0]?.silage)[1] }}万吨</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                            </div>
                                            <div class="name">肉牛繁育</div>
                                            <div class="lineBox">
                                                <div class="item">
                                                    <div class="tit">种公牛存栏</div>
                                                    <div class="num" v-if="initData.dataOne[0]?.bbStorage"><span
                                                            class="bigT">{{ toFloat(initData.dataOne[0]?.bbStorage)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataOne[0]?.bbStorage)[1] }}头</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">年产冷冻精液</div>
                                                    <div class="num" v-if="initData.dataOne[0]?.afsProduction"><span
                                                            class="bigT">{{
                                                            toFloat(initData.dataOne[0]?.afsProduction)[0] }}</span>
                                                        {{ toFloat(initData.dataOne[0]?.afsProduction)[1] }}万剂</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">优质胚胎</div>
                                                    <div class="num" v-if="initData.dataOne[0]?.goodEmbryo"><span
                                                            class="bigT">{{ toFloat(initData.dataOne[0]?.goodEmbryo)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataOne[0]?.goodEmbryo)[1] }}枚</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                            </div>
                                            <div class="name">经营主体</div>
                                            <div class="lineBox">
                                                <div class="item">
                                                    <div class="tit">养殖户</div>
                                                    <div class="num" v-if="initData.dataTwo[0]?.farmer"><span
                                                            class="bigT">{{ toFloat(initData.dataTwo[0]?.farmer)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataTwo[0]?.farmer)[1] }}户</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">养殖合作社</div>
                                                    <div class="num" v-if="initData.dataTwo[0]?.breedingCooperative">
                                                        <span class="bigT">{{
                                                            toFloat(initData.dataTwo[0]?.breedingCooperative)[0]
                                                            }}</span>{{
                                                        toFloat(initData.dataTwo[0]?.breedingCooperative)[1] }}家
                                                    </div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">青储种植企业</div>
                                                    <div class="num" v-if="initData.dataTwo[0]?.cultivationEnterprise">
                                                        <span class="bigT">{{
                                                            toFloat(initData.dataTwo[0]?.cultivationEnterprise)[0]
                                                            }}</span>{{
                                                        toFloat(initData.dataTwo[0]?.cultivationEnterprise)[1] }}家
                                                    </div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="topLeftBox topLeftBox2">
                                    <div class="toptit">二产发展({{ initData.dataThree[0]?.year }})</div>
                                    <div class="countBox">
                                        <div class="left">
                                            <div class="item">
                                                <div class="name">年加工产值</div>
                                                <div class="count">
                                                    <span class="num" v-if="initData.dataThree[0]?.apValue">{{
                                                        toFloat(initData.dataThree[0]?.apValue || '0')[0] }}</span>
                                                    <span class="num" v-else>-</span>
                                                    <br />
                                                    <span class="unit" v-if="initData.dataThree[0]?.apValue">{{
                                                        toFloat(initData.dataThree[0]?.apValue)[1] }}亿元</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <div class="lineBox_two">
                                                <div class="item">
                                                    <div class="tit">龙头企业</div>
                                                    <div class="num" v-if="initData.dataThree[0]?.enterprises"><span
                                                            class="bigT">{{
                                                            toFloat(initData.dataThree[0]?.enterprises)[0] }}</span>
                                                        {{ toFloat(initData.dataThree[0]?.enterprises)[1] }}家</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">活牛屠宰生产线</div>
                                                    <div class="num" v-if="initData.dataThree[0]?.lcsLine"><span
                                                            class="bigT">{{ toFloat(initData.dataThree[0]?.lcsLine)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataThree[0]?.lcsLine)[1] }}万头</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">冷链物流基地</div>
                                                    <div class="num" v-if="initData.dataThree[0]?.cclBase"><span
                                                            class="bigT">{{ toFloat(initData.dataThree[0]?.cclBase)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataThree[0]?.cclBase)[1] }}家</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                                <div class="item">
                                                    <div class="tit">熟食制品加工生产线</div>
                                                    <div class="num" v-if="initData.dataThree[0]?.cffppLine"><span
                                                            class="bigT">{{ toFloat(initData.dataThree[0]?.cffppLine)[0]
                                                            }}</span>
                                                        {{ toFloat(initData.dataThree[0]?.cffppLine)[1] }}家</div>
                                                    <div class="num" v-else>-</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="topMidBox">
                                <div class="top">
                                    <div>
                                        <p class="t">产业现有存栏量({{ toFloat(numberO)[1] }}头)：</p>
                                        <numMove class="numT" v-if="numberO > 0" :id='moveO' :num="numberO"></numMove>
                                        <numMove class="numT" v-else :id='moveO' :num="0"></numMove>

                                        <p class="tit">各苏木养殖信息</p>
                                    </div>
                                    <div>
                                        <p class="t">产业总成交额(万元)</p>
                                        <numMove v-if="numberT > 0" class="numT" :id='move1' :num="numberT"></numMove>
                                        <numMove v-else class="numT" :id='move1' :num="0"></numMove>

                                        <p class="tit">全国交易流向</p>
                                    </div>
                                </div>
                                <div class="flexBox">
                                    <div class="left">
                                        <CanvasContent :index="5" name="mapChar" @click.stop="selectIndex(5)">
                                        </CanvasContent>
                                        <!-- <midMap v-if="midMapData.length > 0" :midMapData='midMapData'></midMap> -->
                                    </div>
                                    <div class="right">
                                        <!-- <chinaMap></chinaMap> -->
                                        <CanvasContent :index="6" name="mapChar" @click.stop="selectIndex(6)"></CanvasContent>
                                    </div>
                                </div>
                            </div>
                            <div class="topRightBox">
                                <div class="toptit">三产发展({{ initData.dataOne[0]?.year }})</div>
                                <div class="boxItem">
                                    <div class="boxTit">
                                        <div class="leftT">
                                            <img src="../../images/icon_tit.svg" alt="">年度销售情况(万)
                                        </div>
                                    </div>
                                    <div class="boxInfo">
                                        <!-- <rightChart01 v-if="chartData1.length > 0" :year='initYear' :chartData1='chartData1'
                                        :yearList="yearList1"></rightChart01> -->
                                        <!-- <rightChart01></rightChart01> -->
                                        <!-- <CanvasContent :index="6" name="barChart" @click.stop="selectIndex(6)"></CanvasContent> -->
                                        <!-- <CanvasContent :index="4" name="circular" @click.stop="selectIndex(4)">
                                        </CanvasContent> -->
                                        <CanvasContent :index="8" name="barChart" @click.stop="selectIndex(8)"></CanvasContent>


                                    </div>
                                </div>
                                <div class="boxItem boxItem2">
                                    <!-- <div class="boxTit">
                                        <div class="leftT"><img src="../../images/icon_tit.svg" alt="">销售渠道分析(万)</div>
                                    </div> -->
                                    <div class="boxInfo">
                                        <CanvasContent :index="4" name="circular" @click.stop="selectIndex(4)">
                                        </CanvasContent>
                                        <!-- <rightChart02 v-if="numberT > 0" :year='initYear1' :chartData2='chartData2'></rightChart02> -->
                                    </div>
                                </div>
                                <div class="boxItem boxItem3">
                                    <div class="boxTit">

                                        <div class="leftT"><img src="../../images/icon_tit.svg" alt="">品类销售情况(万)</div>
                                    </div>
                                    <div class="boxInfo">
                                        <!-- <rightChart03 v-if="chartData3.length > 0" :year='initYear2'
                                            :chartData3='chartData3'>
                                        </rightChart03> -->
                                        <CanvasContent :index="10" name="barChart" @click.stop="selectIndex(10)"></CanvasContent>

                                        <!-- <rightChart03></rightChart03> -->
                                    </div>
                                </div>
                                <!-- <div class="right">
                                    <CanvasContent :index="6" name="mapChar" @click.stop="selectIndex(6)"></CanvasContent>
                                </div> -->
                            </div>
                        </div>
                        <div class="btmBox">
                            <div class="toptit">三品一标可视化</div>
                            <div class="btmLeftBox">
                                <div class="smallTit">
                                    <div class="leftT">
                                        <img src="../../images/icon_tit.svg" alt="">
                                        一院三中心赋能机构
                                    </div>
                                </div>
                                <div class="imgBox1">
                                    <!-- <img src="../../images/keYou/btm_img1.png" alt=""> -->
                                    <div class="leftImg">
                                        <img @click="imgOpen('1')" src="../../images/keYou/btm_img1_1.png" alt="">
                                    </div>
                                    <div class="rightImg">
                                        <img @click="imgOpen('2')" src="../../images/keYou/btm_img1_2.png" alt="">
                                        <img @click="imgOpen('3')" src="../../images/keYou/btm_img1_3.png" alt="">
                                        <img @click="imgOpen('4')" src="../../images/keYou/btm_img1_4.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="btmMidBoxs">
                                <div class="btmMidBox1">
                                    <div class="smallTit">
                                        <div class="leftT">
                                            <img src="../../images/icon_tit.svg" alt="">
                                            肉牛品种
                                        </div>
                                    </div>
                                    <CanvasContent :index="0" name="char" @click.stop="selectIndex(0)"></CanvasContent>
                                </div>
                                <div class="btmMidBox2">
                                    <!-- <div class="smallTit">
                                        <div class="leftT">
                                            <img src="../../images/icon_tit.svg" alt="">
                                            品牌赋能
                                        </div>
                                        <div class="rightT" @click="goPage('/industry/qualityAuditData')">质量监管一张图</div>
                                    </div> -->
                                    <CanvasContent :index="1" name="char" @click.stop="selectIndex(1)"></CanvasContent>
                                    <!-- <relationship v-if="brandList.length>0" :brandList = "brandList"></relationship> -->
                                </div>
                                <div class="btmMidBox3">
                                    <div class="smallTit">
                                        <div class="leftT">
                                            <img src="../../images/icon_tit.svg" alt="">
                                            品质评价
                                        </div>
                                        <!-- <div class="rightT" @click="toHerf()">标准查询</div> -->
                                    </div>
                                    <CanvasContent :index="2" name="pictureCom" @click.stop="selectIndex(2)">
                                    </CanvasContent>
                                    <!-- <div class="imgBox">
                                    <img src="../../images/keYou/btm_img4.png" alt="">
                                </div> -->
                                </div>
                            </div>
                            <div class="btmRightBox">
                                <div class="smallTit">
                                    <div class="leftT">
                                        <img src="../../images/icon_tit.svg" alt="">
                                        标准肉牛产业链
                                    </div>
                                    <!-- <div class="rightT" @click="goPage('/industry/baseMap')">基地一张图</div> -->
                                </div>
                                <div class="commBox">
                                    <!-- <div class="imgBox">
                                    <img src="../../images/keYou/btm_img5.png" alt="">
                                </div> -->
                                    <CanvasContent :index="3" name="pictureCom" @click.stop="selectIndex(3)">
                                    </CanvasContent>
                                    <div class="rightInfo">
                                        <div class="item" v-for="(item, index) in numData" :key="index">
                                            <div class="icon">
                                                <img v-if="index == '1'" src="../../images/keYou/btmBox5_icon2.png"
                                                    alt="">
                                                <img v-else-if="index == '2'" src="../../images/keYou/btmBox5_icon3.png"
                                                    alt="">
                                                <img v-else src="../../images/keYou/btmBox5_icon1.png" alt="">
                                            </div>
                                            <div class="iconT">
                                                <p class="bigT">{{ item.industryName }}</p>
                                                <p><span class="numT">{{ item.count }}</span>个</p>
                                            </div>
                                        </div>
                                        <!-- <div class="item">
                                        <div class="icon">
                                            <img src="../../images/keYou/btmBox5_icon2.png" alt="">
                                        </div>
                                        <div class="iconT">
                                            <p class="bigT">产中标准</p>
                                            <p><span class="numT">7</span>个</p>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="icon">
                                            <img src="../../images/keYou/btmBox5_icon3.png" alt="">
                                        </div>
                                        <div class="iconT">
                                            <p class="bigT">产后标准</p>
                                            <p><span class="numT">8</span>个</p>
                                        </div>
                                    </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-dialog :modal-append-to-body="false" v-model="openFlag" width="120vh" top="8vh"
                        custom-class="customDialog_open">
                        <div class="custom-body">
                            <div class="closeIcon" @click="openFlag = false">
                                <img src="../../images/Cancel.svg" alt="" />
                            </div>
                            <img :src="openUrl" alt="">
                        </div>
                    </el-dialog>
                </div>
            </div>
        </div>
        <!-- <div class="tradePicture" @click="selectProject(true)" :style="{'background-image':canvasConfig.backgroundImage?`url(${commenUrl+canvasConfig.backgroundImage})`:'','background-color':canvasConfig.background?canvasConfig.background:'','width':canvasConfig.width+'px','height':canvasConfig.height+'px',}"> 
        
    </div> -->
    </div>


</template>
<script setup>
import { ref, computed, onMounted, getCurrentInstance, watch } from 'vue'


import CanvasContent from "../../components/CanvasPage/CanvasContent";
import numMove from "../../../bigData/components/keYou/dataCenter/numMove.vue";
import { useStore } from 'vuex';
import mapData from '../../../bigDataDecoration/components/ComponentInstance/components/json/mapData.json'
import { colorCustomMerge, cloneDeep } from '../../utils'// 
const { proxy } = getCurrentInstance();
const store = useStore();
const project = ref(computed(() => store.state.project));
const canvasConfig = ref(computed(() => store.state.chartData.canvasConfig));
const componentList = ref(computed(() => store.state.chartData.componentList));
const requestConfig = ref(computed(() => store.state.chartData.requestConfig))
const comChartColors = ref(colorCustomMerge())   //获取选中颜色


const selectIndex = (index) => {
    project.value.index = index
    selectProject(false)
}
const selectProject = (projectShow) => {
    project.value.projectShow = projectShow
    store.commit("setProject", project.value);
}
const setProjectId = (id) => {
    project.value.id = id
    store.commit("setProject", project.value);
}
const colorkey = ref(canvasConfig.value.theme != '' ? canvasConfig.value.theme : 'chalk')
const color = ref(JSON.parse(JSON.stringify(comChartColors.value[colorkey.value].color)))
// watch(() => canvasConfig.value.theme, (newVal, oldVal) => {
//     if (newVal) {
//         color.value = JSON.parse(JSON.stringify(comChartColors.value[canvasConfig.value.theme].color))
//         fn()
//     }
// }, { deep: true }

// )
const chartDatas = ref(computed(() => store.state.chartData));

// 数据初始化及请求
const dataFind = (i) => {

    proxy
    .$request({
        url: "BIGDATA_BASIC_PRICE_CONFIG_FIND_DETAIL",
        method: "post",
        data: {
            "path": "test/one"
        },
    })
    .then((res) => {
        if (res.data.code == "000") {
          console.log('打印初始化option')
          console.log(JSON.parse(res.data.result.contents))
            setProjectId(res.data.result.id)
            store.commit("setChartData", JSON.parse(res.data.result.contents));
            // 接口请求初始化
            initRequest()
        }
    })
    .catch((err) => {
        console.log(err);
    });
}
dataFind()
// 接口请求及初始化数据与绑定合并   
const dataRequest = (i, t) => {
    const componentJson = chartDatas.value.componentList[i]
    if (!componentJson.config.requestConfig.url) return
    let data = {}
    // 基础请求参数处理
    componentJson.config.requestConfig.data.forEach(element => {
        data[element.label] = element.value
    });
    // 全局请求参数处理
    let isRuest = false
    const requestData = JSON.parse(JSON.stringify(chartDatas.value.requestConfig.data))
    componentJson.config.requestConfig.bindData.forEach(m => {
        let bindJson = requestData.find(s => s.label == m.label)
        if (bindJson && !data[m.label]) {
            if (m.value != bindJson.value && t) {
                isRuest = true
            }
            data[bindJson.label] = m.value = bindJson.value
        }
    });
    if (!isRuest) {
        return
    }
    proxy
        .$request({
            url: componentJson.config.requestConfig.url,
            method: "post",
            data: data,
        })
        .then((res) => {
            if (res.data.code == "000") {
                // chartData.value.componentList[i].data = res.data.result
                // 数据格式不对  数据暂时固定
                // chartData.value.componentList[i].data = {
                //     legendData: ['层级一', '层级二', '层级三'],
                //     myGraphData: [
                //         { "parentNode": "李四", "childNodes": ["小明", "小华", "小杰", "小a婷", "小a妍", "小a飞"] },
                //     ]
                // }
                // store.commit("setChartData", chartData.value);
            }
        })
        .catch((err) => {
            console.log(err);
        });
}
// 循环图表根据数据来源进行请求处理
const initRequest = (t) => {
    chartDatas.value.componentList.forEach((e, index) => {
        if (e.config.baseConfig.dataFrom == '2') {
            dataRequest(index, t)
        }
    })
}


// 监听绑定数据信息变化
watch(() => store.state.chartData.requestConfig, (newVal, oldVal) => {
    if (newVal) {
        initRequest(true)
    }
}, { deep: true }

)

// 获取浏览器可视区域宽高
const innerWidth = ref(window.innerWidth)
const innerHeight = ref(window.innerHeight)
console.log(innerWidth, innerHeight, '可视区域尺寸', window)
// innerWidth/chartDatas.canvasConfig.width,innerHeight/chartDatas.canvasConfig.height
const handleResize = () => {
    console.log('尺寸变化')
    innerWidth.value = window.innerWidth
    innerHeight.value = window.innerHeight
}

// 添加事件监听器
window.addEventListener('resize', handleResize);




const activeIndex = ref('0')
const navList = ref([
    {
        name: '肉牛产业链',
        value: '0',
        url: 'dataCenter'
    },
    {
        name: '产业园发展概览',
        value: '1',
        url: 'baseMap'
    }, {
        name: '产业交易中心',
        value: '2',
        url: 'tradePicture'
    }, {
        name: '肉牛价格指数',
        value: '3',
        url: 'https://kerqinbeefindex.cn/home/databoard',
        type: '1'
    }, {
        name: '品牌运营面板',
        value: '4',
        url: 'brandYuny'
    }, {
        name: '肉牛品质评价',
        value: '5',
        url: 'qualityEvaluation'
    }, {
        name: '产业标准体系',
        value: '6',
        url: 'https://www.kyzqniuye.com/bzcx-admin/kyoutside',
        type: '1'
        // },{
        //     name:'产业安防平台',
        //     value:'7',
        //     url:'https://111.57.151.198:442/portal/ui/index',
        //     type:'1'
    },
])
const activeId = ref('')
const yearChange = (i) => {
    activeId.value = i.id;
    store.commit("setRequestConfig", [{ label: 'year', value: i.id }]);
}
const numberO = ref(0)
const numberT = ref(0)
const moveO = ref('moveO')
const move1 = ref('move1')
const dataList = ref([])
const yearList = ref([])
const initYear = ref();
const initYear1 = ref(initYear.value)
const initYear2 = ref(initYear.value)
const yearList1 = ref([])
const numMoveFlag = ref(false)
const getYearData = () => {
    proxy.$request({
        url: "KY_BEEF_YEARLIST",
        method: "post",
        data: {},
    }).then((res) => {
        if (res.data.code == '000') {
            let data = res.data.result.map(i => i.year);
            yearList1.value = data;
            let currentYear = (new Date().getFullYear());
            if ((data.findIndex(i => i == currentYear)) > -1) {
                numMoveFlag.value = true;
                initYear.value = currentYear;
            } else {
                numMoveFlag.value = false;
                initYear.value = data[0]
            }
            initYear1.value = ref(initYear.value)
            initYear2.value = ref(initYear.value)
            yearList.value = data.map(e => {
                let a = {
                    'year': e,
                    'id': e,
                }
                return a
            })
            dataInit(initYear.value)
        } else {
            proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                confirmButtonText: '确定',
            });
        }
    }).catch((err) => {
        console.log(err)
    })
}
getYearData()
const initData = ref({
    dataOne: [],
    dataTwo: [],
    dataThree: [],
})
const chartData = ref('')
proxy.$request({
    url: "N_PORTAL_VARIETY_LIST",
    method: "post", //可以不传method 默认是post请求，
    data: {},
}).then((res) => {
    // console.log(res)
    let list = []
    if (res.data.result.pVarietyMageListVos.length > 0) {
        list = res.data.result.pVarietyMageListVos.map(e => {
            return {
                enabledStatus: e.enabledStatus,
                varietyName: e.varietyName
            }
        })
    }
    chartData.value = JSON.stringify(list)
})
const chartData1 = ref([]);
const getChartData1 = () => {
    proxy.$request({
        url: "TRADE_NY_SALETRENDYEAR",
        method: "post",
        data: {},
    }).then((res) => {
        if (res.data.code == '000') {
            let data = res.data.result;
            chartData1.value = data
            // console.log(chartData1.value,'www')
        } else {
            proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                confirmButtonText: '确定',
            }).catch(() => { });
        }
    }).catch((err) => {
        console.log(err)
    })
}
const chartData2 = ref([]);
const getChartData2 = () => {
    chartData2.value = [
        {
            "value": 0,
            "name": "大庙市场"
        },
        {
            "value": 0,
            "name": "公域平台"
        },
        {
            "value": 0,
            "name": "私域平台"
        },
        {
            "value": 0,
            "name": "线下"
        },
    ]
    // numberT.value = 0;
    proxy.$request({
        url: "TRADE_NY_INDUSTRY",
        method: "post",
        data: {
            year: initYear.value
        },
    }).then((res) => {
        if (res.data.code == '000') {
            let data = res.data.result;
            numberT.value = Math.round(proxy.tool.convertToWanFormatted(data.payableAmount || 0));
            chartData2.value[0].value = proxy.tool.convertToWanFormatted(data.dmNyNum || 0)
            chartData2.value[1].value = proxy.tool.convertToWanFormatted(data.pubNum || 0)
            chartData2.value[2].value = proxy.tool.convertToWanFormatted(data.priNum || 0)
            chartData2.value[3].value = proxy.tool.convertToWanFormatted(data.offLineNum || 0)
            initYear1.value = String(initYear.value)
        } else {
            proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                confirmButtonText: '确定',
            });
        }
    }).catch((err) => {
        console.log(err)
    })
}
// getChartData2();
const chartData3 = ref([]);
const getChartData3 = () => {
    chartData3.value = [];
    proxy.$request({
        url: "TRADE_NY_SALENAME",
        method: "post",
        data: {
            "year": initYear.value,
        },
    }).then((res) => {
        if (res.data.code == '000') {
            let data = res.data.result;
            chartData3.value = data?.slice(-4);
            initYear2.value = String(initYear.value)
        } else {
            proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                confirmButtonText: '确定',
            });
        }
    }).catch((err) => {
        console.log(err)
    })
}
// getChartData3();
const typeId = ref('')
proxy.$request({
    url: "STANDARD_FINDWHOLECHAINLIST_NOPAGE",
    method: "post",
    data: {
        "referenceStatus": "0",
    },
}).then((res) => {
    if (res.data.code == '000') {
        // let j = res.data.result.find(i=>i.styleColor =='3');
        typeId.value = res.data.result[0].id
        getTypeData(typeId.value)
    } else {
        proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
            confirmButtonText: '确定',
        });
    }
})
const numData = ref([])
const getTypeData = (id) => {
    proxy.$request({
        url: "STANDARD_FISTIDUSTRY",
        method: "post",
        data: {
            "id": id
        },
    }).then((res) => {
        // console.log(res.data.result,'wwww')
        if (res.data.code == '000') {
            numData.value = res.data.result
        } else {
            proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                confirmButtonText: '确定',
            });
        }
    })
}
const getId = (id) => {
    numberO.value = 0;
    if (id) {
        dataInit(id)
        initYear.value = id;
    }
    getChartData2();
    getChartData3();
}
getId();
const openFlag = ref(false)
const openUrl = ref('')
const imgOpen = (type) => {
    if (type == '1') {
        openUrl.value = require('../../images/keYou/btm_open1.png')
    } else if (type == '2') {
        openUrl.value = require('../../images/keYou/btm_open2.png')
    } else if (type == '3') {
        openUrl.value = require('../../images/keYou/btm_open3.png')
    } else if (type == '4') {
        openUrl.value = require('../../images/keYou/btm_open4.png')
    }
    openFlag.value = true;
}
const midMapData = ref([])
const getMidMap = () => {
    proxy.$request({
        url: "KY_BEEF_CITYLIST",
        method: "post",
    }).then((res) => {
        // console.log(res.data.result)
        midMapData.value = res.data.result
    })
}
getMidMap()
const currentData = ref(0)
const dataInit = (year) => {
    proxy.$request({
        url: "KY_BEEF_BEEFGROW",
        method: "post",
        data: {
            "year": year
        },
    }).then((res) => {
        // console.log(res)
        initData.value = res.data.result;
        let currentYear = (new Date().getFullYear());
        if (year == currentYear) {
            currentData.value = Math.ceil(Number(initData.value.dataTwo[0]?.bcStorage || 0) * 10000)
        }
        if (numMoveFlag.value) {
            numberO.value = currentData.value
        } else {
            numberO.value = Math.ceil(Number(initData.value.dataTwo[0]?.bcStorage || 0) * 10000)
        }
    })
}
const brandList = ref([])
const brandData = () => {
    proxy.$request({
        url: "KY_BEEF_BRANDLIST",
        method: "post",
        data: {},
    }).then((res) => {
        // console.log(res.data.result)
        let res1 = res.data.result;
        if (res1.length > 0) {
            const parent = [...new Set(res1.map(item => item.companyShort))];
            res1.forEach(e => {
                if (brandList.value.findIndex(m => m.parentNode == e.companyShort) > -1) {
                    brandList.value[brandList.value.findIndex(m => m.parentNode == e.companyShort)].childNodes.push(e.brandName)
                } else {
                    brandList.value.push(
                        {
                            parentNode: e.companyShort,
                            childNodes: [e.brandName]
                        }
                    )
                }
            })
            brandList.value.unshift({
                parentNode: '科右中旗牛肉',
                childNodes: parent
            })
            // console.log(brandList.value)
        }
    })
}

const toFloat = (num) => {
    let text = num.toString()
    let html = `<span style="font-size: 0.62vw">亿</span>`
    let htmlList = []
    if (text.length > 8) {
        htmlList.push((Number(num) / 100000000).toFixed())
        htmlList.push('亿')
    } else {
        htmlList.push(Number(num))
        htmlList.push('')
    }
    return htmlList;
}
onMounted(() => {
    getChartData1();
    brandData();
})

</script>
<style lang="less" scoped>
.full {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden
}

.test_one {
    // width:1920px;
    // height: 1080px;
    transform-origin: center center;

    .topHeaderOne {
        width: 100%;
        position: relative;
        height: 75.6px;
        /* 7vh * (1080px / 100) */
        background: url(../../images/keYou/tit_bg.png) 0 0 no-repeat;
        background-size: 100% 100%;
        display: flex;
        background-color: #0c1c3c;

        .titBox {
            padding-left: 76.8px;
            /* 4vw * (1920px / 100) */
            line-height: 75.6px;
            /* 7vh * (1080px / 100) */
            display: flex;
            align-items: center;

            .t {
                font-family: MyTit;
                font-size: 28.8px;
                /* 1.5vw * (1920px / 100) */
                letter-spacing: 7.68px;
                /* 0.4vw * (1920px / 100) */
                color: #FFFFFF;
            }

            .icon {
                cursor: pointer;
                display: inline-block;
                width: 46.08px;
                /* 2.6vw * (1920px / 100) */
                line-height: 34.56px;
                /* 1.9vw * (1920px / 100) */
                height: 28.8px;
                /* 1.6vw * (1920px / 100) */
                border-radius: 28.8px;
                /* 1.6vw * (1920px / 100) */
                text-align: center;
                background: linear-gradient(180deg, rgba(7, 132, 181, 0) 0%, #00689F 100%);
                color: #FFFFFF;
            }
        }

        .navBox {
            margin-left: 38.4px;
            /* 2vw * (1920px / 100) */
            display: flex;
            align-items: center;
            height: 75.6px;
            /* 5.4vh * (1080px / 100) */
            line-height: 75.6px;
            /* 5.4vh * (1080px / 100) */

            .item {
                cursor: pointer;
                display: flex;

                .name {
                    font-family: MyTit;
                    font-size: 17.664px;
                    /* 0.94vw * (1920px / 100) */
                    color: #36DBFF;
                    display: inline-block;
                    padding: 0 12.96px;
                    /* 0.7vw * (1920px / 100) */
                    height: 75.6px;
                    /* 5.4vh * (1080px / 100) */
                }

                .lineIcon {
                    width: 1px;
                }
            }

            .item.active .name {
                color: #FFFFFF;
                background: url(../../images/keYou/navItem_bg.png) 0 0 no-repeat;
                background-size: 100% 96%;
            }
        }

        .dateBox {
            flex: 1;
            padding-top: 26.88px;
            /* 1.4vh * (1080px / 100) */
            line-height: 49.92px;
            /* 2.6vh * (1080px / 100) */
            font-family: MyTit;
            font-size: 12.96px;
            /* 0.7vw * (1920px / 100) */
            color: #36DBFF;
            padding-right: 96px;
            /* 5vw * (1920px / 100) */
            text-align: right;
        }
    }
}


.customDialog_open {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    box-shadow: none;
    top: 108px;
    /* 10vh * (1080px / 100) */
    margin: 0 auto !important;
    ;

    .el-dialog__header {
        display: none !important;
    }

    .el-dialog__body {
        padding: 0;
    }

    .custom-body {
        height: 864px !important;
        /* 80vh * (1080px / 100) */
        position: relative;
        padding: 0;

        .closeIcon {
            position: absolute;
            right: 30px;
            top: 30px;
            cursor: pointer;

            img {
                width: 30px;
            }
        }

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.dataCenter {
    * {
        box-sizing: border-box;
        margin: 0;
    }

    position: relative;
    // padding: 0 19.648px; /* 1.042vw * (1920px / 100) */
    width: 100%;
    height: 1004px;
    /* 93vh * (1080px / 100) */
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: url(../../images/keYou/dataCenter_bg.png) 0 0 no-repeat;
    background-size: 100% 100%;

    .timeline {
        z-index: 99;
        width: 100%;
        display: flex;
        justify-content: center;
        position: relative;
        top: 940px;
        /* 89.2vh * (1080px / 100) */

        .item {
            display: flex;
            align-items: center;

            .time {
                position: relative;
                font-size: 17.28px;
                /* 0.9vw * (1920px / 100) */
                line-height: 1.728px;
                /* 1vw * (1920px / 100) */
                padding: 16px 11.52px;
                /* 0.4vh * (1080px / 100) */
                background: #23230d;
                color: #7b7b6d;
                cursor: pointer;
                border-radius: 8px;
            }

            .time::after {
                content: '';
                position: absolute;
                top: calc(50% - 4px);
                left: calc(100% + 3px);
                margin-left: -8px;
                border-width: 8px 8px 0;
                border-style: solid;
                border-color: #23230d transparent transparent;
                transform: rotate(270deg);
            }

            .line {
                margin: 0 38.4px 0 26.88px;
                /* 0.5vw * (1920px / 100) */
                width: 9.6px;
                /* 0.5vw * (1920px / 100) */
                height: 9.6px;
                /* 0.5vw * (1920px / 100) */
                background-color: #666421;
                border-radius: 50%;
            }
        }

        .activeItem {
            .time {
                background: #FFCC00;
                color: #001529;
            }

            .time::after {
                border-color: #FFCC00 transparent transparent;
            }

            .line {
                background-color: #FFCC00;
            }
        }
    }

    .container {
        height: calc(1080px - 84px);
        flex: 1;

        .smallTit {
            display: flex;
            justify-content: space-between;
            height: 22px;
            /* 2.037vh * (1080px / 100) */
            line-height: 22px;
            /* 2.037vh * (1080px / 100) */

            .leftT {
                font-size: 16px;
                color: #a8c4d7;
            }

            // .rightT {
            //     cursor: pointer;
            //     font-size: 12px;
            //     color: #a8c4d7;
            //     text-decoration: underline;
            // }

        }

        .countBox {
            display: flex;

            .left {
                width: 138.5px;
                /* 7.24vw * (1920px / 100) */

                .item {
                    height: 162px;
                    /* 15vh * (1080px / 100) */
                    background: url(../../images/keYou/leftCount_bg.png) center center no-repeat;
                    background-size: 100% 100%;
                    color: #36DBFF;
                    text-align: center;
                    margin-top: 15.12px;
                    /* 1.4vh * (1080px / 100) */

                    .name {
                        font-size: 14px;
                        line-height: 43.2px;
                        /* 4vh * (1080px / 100) */
                    }

                    .count {
                        font-size: 13.824px;
                        /* 0.72vw * (1920px / 100) */

                        .num {
                            display: inline-block;
                            padding-top: 10.8px;
                            /* 1vh * (1080px / 100) */
                            font-size: 32.064px;
                            /* 1.77vw * (1920px / 100) */
                        }
                    }
                }
            }

            .right {
                flex: 1;
                text-align: center;

                .name {
                    display: inline-block;
                    color: #36DBFF;
                    margin: 15.12px 0 17.28px;
                    /* 1.4vh * (1080px / 100) */
                    font-size: 13.824px;
                    /* 0.72vw * (1920px / 100) */
                    height: 32.4px;
                    /* 3vh * (1080px / 100) */
                    text-align: center;
                    line-height: 32.4px;
                    /* 3vh * (1080px / 100) */
                    background: url(../../images/keYou/leftName_bg.png) 100% no-repeat;
                    background-size: 100% 100%;
                    width: 93.6px;
                    /* 4.9vw * (1920px / 100) */
                }

                .lineBox {
                    display: flex;

                    .item {
                        font-size: 13.824px;
                        /* 0.72vw * (1920px / 100) */
                        color: #FFFFFF;
                        width: 33%;
                        /* 33% */

                        .num {
                            height: 25.92px;
                            /* 2.4vh * (1080px / 100) */
                            margin-top: 2.16px;
                            /* 0.2vh * (1080px / 100) */
                            color: #36DBFF;
                            font-size: 11.184px;
                            /* 0.62vw * (1920px / 100) */

                            .bigT {
                                font-size: 17.28px;
                                /* 0.93vw * (1920px / 100) */
                            }
                        }
                    }
                }

                .lineBox_two {
                    display: flex;
                    flex-wrap: wrap;

                    .item {
                        margin-top: 21.6px;
                        /* 2vh * (1080px / 100) */
                        width: 50%;
                        /* 50% */
                        font-size: 13.824px;
                        /* 0.72vw * (1920px / 100) */
                        color: #FFFFFF;
                        margin-bottom: 10.8px;
                        /* 1vh * (1080px / 100) */

                        .num {
                            margin-top: 2.16px;
                            /* 0.2vh * (1080px / 100) */
                            color: #36DBFF;
                            font-size: 11.184px;
                            /* 0.62vw * (1920px / 100) */

                            .bigT {
                                font-size: 17.28px;
                                /* 0.93vw * (1920px / 100) */
                            }
                        }
                    }
                }
            }
        }

        .topBox {
            display: flex;
            justify-content: space-between;
            height: 648px;
            /* 60vh * (1080px / 100) */
            margin: 0 20px 21.6px;

            .top {
                display: flex;
                justify-content: space-around;

                p.t {
                    text-align: center;
                    color: #ffffff;
                    background: transparent;
                    height: 25px;
                    /* 2.315vh * (1080px / 100) */
                    margin-top: 23px;
                    /* 2.13vh * (1080px / 100) */
                    font-family: PingFangSC-Semibold;
                    font-size: 18px;
                    /* 0.938vw * (1920px / 100) */
                }

                .tit {
                    width: 200px;
                    /* 10.573vw * (1920px / 100) */
                    height: 63px;
                    /* 3.333vh * (1080px / 100) */
                    background: url(../../images/tit_icon.png) center center no-repeat;
                    background-size: 100% 100%;
                    color: #ffffff;
                    font-size: 16px;
                    /* 0.833vw * (1920px / 100) */
                    line-height: 63px;
                    /* 3.333vh * (1080px / 100) */
                    align-self: center;
                    text-align: center;
                    margin: 0 auto;
                }
            }

            .top>div .numT {
                padding: 26px 57px 24px;
                /* 2.407vh * (1080px / 100), 2.969vw * (1920px / 100), 2.222vh * (1080px / 100) */
                background: url(../../images/countTit_bg.png) 0 no-repeat;
                background-size: 100% 100%;
            }

            .topLeftBox,
            .topRightBox {
                padding: 50px 20px 16px 20px;
                /* 4.63vh * (1080px / 100), 1.042vw * (1920px / 100), 1.481vh * (1080px / 100), 1.042vw * (1920px / 100) */
                position: relative;
                background: url(../../images/topBox_bg.png) 0 0 no-repeat;
                background-size: 100% 100%;
                width: 440px;
                /* 23.073vw * (1920px / 100) */

                .toptit {
                    width: 390px;
                    /* 20.73vw * (1920px / 100) */
                    position: absolute;
                    top: -4px;
                    padding: 4.4px 0;
                    font-size: 18px;
                    /* 18px * (1920px / 100) */
                    letter-spacing: 2px;
                    color: #36dbff;
                    text-align: center;
                    background: url(../../images/topBoxTit_bg.png) center center no-repeat;
                    background-size: 88% 100%;
                }

                .chartBox {
                    padding-top: 24px;
                    /* 2.2vh * (1080px / 100) */
                }

                .boxItem {
                    height: 183.6px;
                    /* 17vh * (1080px / 100) */
                    font-size: 16px;
                    /* 16px * (1920px / 100) */
                    color: #A8C4D7;

                    .boxTit {
                        height: 38px;
                        /* 2.037vh * (1080px / 100) */
                        display: flex;
                        align-items: center;

                        .leftT {
                            line-height: 38px;
                            /* 2.037vh * (1080px / 100) */
                            font-size: 16px;
                            /* 16px * (1920px / 100) */
                            color: #A8C4D7;
                            display: flex;

                            img {
                                margin-right: 8px;
                            }
                        }
                    }

                    .boxInfo {
                        height: 162px;
                        /* 15vh * (1080px / 100) */
                        // padding: 20px;
                    }
                }

                .boxItem2 {
                    margin-top: 10.8px;
                    /* 1vh * (1080px / 100) */
                    height: 194.4px;
                    /* 18vh * (1080px / 100) */

                    .boxTit {
                        align-items: center;
                        justify-content: space-between;
                    }
                }
            }

            .boxItem3 {
                height: 172.8px;
                /* 16vh * (1080px / 100) */

                .boxTit {
                    align-items: center;
                    justify-content: space-between;
                }
            }

            .topLeftBox1 {
                height: 410.4px;
                /* 38vh * (1080px / 100) */
                margin-bottom: 21.6px;
                /* 2vh * (1080px / 100) */
            }

            .topLeftBox2 {
                height: 216px;
                /* 20vh * (1080px / 100) */
                padding-top: 27px;
                /* 2.5vh * (1080px / 100) */
            }

            .topMidBox {
                width: 987.6px;
                /* 52% * (1920px / 100) */
                height: 100%;
                /* 100% */

                .top {
                    width: 100%;
                    /* 100% */
                    height: 198.72px;
                    /* 18.24vh * (1080px / 100) */
                }

                .flexBox {
                    display: flex;
                    justify-content: space-evenly;
                    height: 432px;
                    /* 40vh * (1080px / 100) */
                    position: relative;

                    .left {
                        position: absolute;
                        left: 0;
                        top: -150px; /* -20vh * (1080px / 100) */
                        height: 546px; /* 60vh * (1080px / 100) */
                        width: 50%; /* 56% * (1920px / 100) */
                        display: flex;
                        flex-direction: column;
                        z-index: 9999;
                    }

                    .right {
                        margin-left: auto;
                        width: 50%;
                        /* 50% * (1920px / 100) */
                        display: flex;
                        flex-direction: column;
                    }
                }
            }
        }

        .btmBox {
            position: relative;
            height: 280.8px;
            /* 26vh * (1080px / 100) */
            margin: 0 20px 10.8px;
            /* 1% * (1080px / 100) */
            display: flex;
            justify-content: space-between;
            background: url(../../images/btmBox_bg.png) 0 0 no-repeat;
            background-size: 100% 100%;

            .imgBox {
                height: 216px;
                /* 20vh * (1080px / 100) */

                img {
                    width: 100%;
                    height: 237.6px;
                    /* 22vh * (1080px / 100) */
                }
            }

            .imgBox1 {
                padding-left: 11.52px;
                /* 0.6vw * (1920px / 100) */
                padding-right: 0px;
                padding-top: 11.52px;
                /* 0.6vw * (1920px / 100) */
                display: flex;
                height: 216px;
                /* 20vh * (1080px / 100) */

                img {
                    width: 100%;
                    cursor: pointer;
                }

                .leftImg {
                    width: 422.4px;
                    /* 22vw * (1920px / 100) */
                }

                .rightImg {
                    width: 417.6px;
                    /* 21.88vw * (1920px / 100) */
                    padding-top: 23.04px;
                    /* 1.2vw * (1920px / 100) */

                    img {
                        height: 38.4px;
                        /* 2vw * (1920px / 100) */
                        margin-bottom: 7.68px;
                        /* 0.4vw * (1920px / 100) */
                        margin-left: -15.36px;
                        /* -0.8vw * (1920px / 100) */
                    }

                    img:nth-child(2) {
                        margin-left: 7.392px;
                        /* 0.37vw * (1920px / 100) */
                    }
                }
            }

            .toptit {
                width: 1920px;
                /* 100% */
                position: absolute;
                top: -42px;
                padding: 8px 0;
                font-size: 20px;
                letter-spacing: 1px;
                color: #36dbff;
                text-align: center;
                background: url(../../images/icon_bottom.png) center center no-repeat;
                background-size: 28% 100%;
            }
        }

        .btmLeftBox,
        .btmRightBox {
            padding: 22.032px 19.608px;
            width: 443.76px;
            border-right: 1px dashed #1971a8;

            .smallTit {
                height: 38.16px;
                line-height: 38.16px;
            }

            .commBox {
                display: flex;

                .imgBox {
                    flex: 1;
                }

                .rightInfo {

                    width: 98.768px;

                    .item {
                        display: flex;
                        margin-bottom: 22.08px;

                        .icon {
                            width: 42.336px;
                            height: 42.336px;
                            border-radius: 42.336px;

                            img {
                                width: 42.336px;
                                height: 42.336px;
                            }
                        }

                        .iconT {
                            color: #96a0b5;
                            font-size: 10.048px;
                            margin-left: 19.2px;

                            .bigT {
                                line-height: 14px;
                                font-size: 12.096px;
                            }

                            .numT {
                                margin-right: 6px;
                                color: #36dbff;
                                font-size: 16.064px;
                                font-weight: bold;
                            }
                        }
                    }
                }

                .leftInfo {
                    margin-right: 7.68px;
                }

                .rightInfo {
                    margin-left: 7.68px;
                }
            }
        }

        .btmMidBoxs {
            width: 996px;
            /* 53.854vw * (1920px / 100) */
            display: flex;
            justify-content: space-between;

            .btmLeftBox {
                padding: 15px;
            }

            .btmMidBox1,
            .btmMidBox2,
            .btmMidBox3 {
                padding: 12.96px 20px 0;
                /* 1.204vh * (1080px / 100), 1.042vw * (1920px / 100), 0 */
                width: 646.4px;
                /* 33% * (1920px / 100) */
                position: relative;

                .smallTit {
                    height: 21.984px;
                    /* 2.037vh * (1080px / 100) */
                    line-height: 21.984px;
                    margin-top: 5.4px;
                    /* 0.5vh * (1080px / 100) */
                    margin-bottom: 0;
                }

                .btmTit {
                    width: 1920px;
                    /* 100% */
                    height: 108px;
                    /* 10% * (1080px / 100) */
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 12px;
                    color: #ffffff;
                    background: url(../../images/icon_bottom.png) 0 0 no-repeat;
                    background-size: 100% 100%;
                }
            }

            .btmMidBox2 {
                border-left: 1px dashed #1971a8;
                border-right: 1px dashed #1971a8;
            }
        }

        .btmRightBox {
            padding: 13px 20px;
            border-right: none;
            border-left: 1px dashed #1971a8;
        }
    }

    .mkPad {
        margin: 3.996px 0 0;
        /* 0.37vh * (1080px / 100), 0, 0 */
    }
}
</style>
